import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  inject,
} from '@angular/core';
import { Numbers } from '../utils/numbers';

@Directive({ selector: '[appRestrictDollarDecimalPoint]' })
export class RestrictDollarDecimalPointDirective {
  private readonly el = inject(ElementRef);

  @Output() public numericValue = new EventEmitter<string>();
  private readonly regex = new RegExp(/^\d*\.?\d{0,2}/);
  private readonly specialKeys: string[] = ['Backspace', 'Tab', 'End', 'Home', 'Ctrl', 'v', 'ArrowLeft', 'ArrowRight'];
  @HostListener('input', ['$event'])
  public onKeyDown(event: KeyboardEvent): void {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current = String(Numbers.convertFromDollarsToString(this.el.nativeElement.value));
    const match: RegExpMatchArray = current.match(this.regex);

    let value = match[0] || '';

    value = `$${value}`;
    this.el.nativeElement.value = value;
    this.numericValue.emit(value);
  }
}
